import dayjs from "dayjs";
import i18n from "@/i18n/index";
import type { ManipulateType } from 'dayjs';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import html2canvas from "html2canvas";
import * as XLSX from "xlsx";

// Extend jsPDF with autoTable
(jsPDF as any).API.autoTable = autoTable;


import { ref } from 'vue';
import { useAuthenticatedFetch } from '../auth/useAuthenticatedFetch'; 
import { useGlobal } from "@/composables/global/useGlobal";
import { setDefaultImage, getImageUrl } from '@/utils/global'
const { authenticatedFetch } = useAuthenticatedFetch();
const API_URL = process.env.VUE_APP_ROOT_API;
export function useMembersPDF() {
    const error = ref<string | null>(null);
    const isRequestPDF = ref<boolean | false>(false);
    const errorPDF = ref<boolean | false>(false);
 
    const { formatDate, translateToFrench } = useGlobal();

    const exportMembersPDF = async (data: any, typeName: string, typeOfFile:string ) => {
        // Create a new jsPDF instance         
         const doc = new jsPDF({
           orientation: "landscape",
           unit: "mm",
           format: "a4",
         });
        
        const headers = [
          // translateToFrench('tables.members.matricule'),
          translateToFrench("tables.members.contractNumber"),
          translateToFrench("tables.members.cin"),
          translateToFrench("tables.members.name"),

          translateToFrench("tables.members.tele"),
          //   translateToFrench('tables.members.dateBirth'),
          translateToFrench("tables.members.seller"),
          translateToFrench("tables.members.status"),
        ];
        const members: Array<[ string, string, string, string, string, string]> = [];
        if (data?.members) {
            data?.members?.map((item, index) => {
                members.push(
                    [
                        // item.matricule ? item?.matricule?.toString() || '-' : '-',
                         item.contractNumber ? item?.contractNumber?.toString() || '-' : '-',
                        item.cin ? item?.cin?.toString() || '-' : '-',
                        item.name ? item?.name?.toString() || '-' : '-',
                       
                        item.tele ? item?.tele?.toString() || '-' : '-',
                        //   item.dateBirth ? formatDate(item?.dateBirth) || '-' : '-',
                        item.seller?.name ? item?.seller?.name?.toString() || '-' : '-',
                        item.subscription_status ?  translateToFrench('status.' + item?.subscription_status?.toString()  ) || '-' : '-',
                    ]
                );
            })

        }


        // Define articles with varying content types
        const firstArticles: any = [
            {
                type: "article",
                table: {
                    headers: headers,
                    data: members
                }
            }
        ];


        // Define articles with varying content types
        const articles: any = [

        ];

        // Parameters for positioning

        const pageWidth = doc.internal.pageSize.getWidth(); // Full page width
        const pageHeight = doc.internal.pageSize.getHeight(); // Full page height
        let y = 10;
        const descriptionMarginBottom = 2;
        const descriptionLineHeight = 4;
        const titleMarginBottom = 4;
        const tableMarginBottom = 4;
        const lineHeight = 10;
        const leftX = 10;


        function addPage() {
            if (y + lineHeight + 6 > pageHeight) {
                doc.addPage(); // Create a new page
                y = 10; // Reset y position
            }
        }



        // Helper function to add personal information
        function searchInfo() {
            if (data?.filterBy?.name) {
                y += 4.5;
                doc.setFont("helvetica", "normal", "normal");
                doc.setFontSize(10);
                doc.text(translateToFrench('tables.members.name') + " : " + data?.filterBy?.name, leftX, y);
            }
            if (data?.filterBy?.email) {
                y += 4.5;
                doc.setFont("helvetica", "normal", "normal");
                doc.setFontSize(10);
                doc.text(translateToFrench('tables.members.email') + " : " + data?.filterBy?.email, leftX, y);
            }
            if (data?.filterBy?.tele) {
                y += 4.5;
                doc.setFont("helvetica", "normal", "normal");
                doc.setFontSize(10);
                doc.text(translateToFrench('tables.members.tele') + " : " + data?.filterBy?.tele, leftX, y);
            }
            if (data?.filterBy?.cin) {
                y += 4.5;
                doc.setFont("helvetica", "normal", "normal");
                doc.setFontSize(10);
                doc.text(translateToFrench('tables.members.cin') + " : " + data?.filterBy?.cin, leftX, y);
            }
            if (data?.filterBy?.dateBirth) {
                if (data?.filterBy?.dateBirth[0] != null && data?.filterBy?.dateBirth[1]) {
                    y += 4.5;
                    const date = data.filterBy?.dateBirth;
                    doc.setFont("helvetica", "normal", "normal");
                    doc.setFontSize(10);
                    const du = dayjs(String(date[0])).format('DD/MM/YYYY')
                    const ou = dayjs(String(date[1])).format('DD/MM/YYYY')
                    doc.text(translateToFrench('tables.members.dateBirth') + " : " + du + " -- " + ou, leftX, y);
                }
            }
            if (data?.filterBy?.gender) {
                y += 4.5;
                doc.setFont("helvetica", "normal", "normal");
                doc.setFontSize(10);
                doc.text(translateToFrench('tables.members.gender') + " : " + data?.filterBy?.gender, leftX, y);
            }
            if (data?.filterBy?.contractNumber) {
                y += 4.5;
                doc.setFont("helvetica", "normal", "normal");
                doc.setFontSize(10);
                doc.text(translateToFrench('tables.members.contractNumber') + " : " + data?.filterBy?.contractNumber, leftX, y);
            }
            if (data?.filterBy?.seller) {
                y += 4.5;
                doc.setFont("helvetica", "normal", "normal");
                doc.setFontSize(10);
                doc.text(translateToFrench('tables.members.seller') + " : " + data?.filterBy?.seller, leftX, y);
            }
        }

        // Helper function to add title and subtitle on the same line
        function addTitleAndSubtitle(article) {
            addPage()
            // Set title font
            doc.setFont("helvetica", "bold");
            doc.setFontSize(9);
            doc.setTextColor(article?.titleColor ?? "#0030E0"); // Set dynamic color
            doc.text(article?.title, leftX, y);
            // Calculate the width of the title to position the subtitle correctly
            const titleWidth = doc.getTextWidth(article?.title);
            // Set subtitle font and add it next to the title
            if (article?.subtitle) {
                doc.setFont("helvetica", "italic");
                doc.setFontSize(7);
                doc.text(article?.subtitle ?? '', leftX + titleWidth + 5, y); // Add a small space after title
            }
            // Set subtitle font and add it next to the title
            if (article?.priceTitle) {
                doc.setFont("helvetica", "normal", "bold");
                doc.setFontSize(9);
                doc.setTextColor(0, 0, 0); // Set dynamic color
                doc.text(article?.priceTitle ?? '', leftX + titleWidth + 3, y); // Add a small space after title
            }
            y += titleMarginBottom;
        }

        // Helper function to add article description
        function addDescription(article) {
            addPage()
            const font = article?.descriptioBold ? "bold" : "normal"
            const size = article?.descriptioBold ? 8 : 7
            doc.setFontSize(size);
            doc.setFont("helvetica", "normal", font);
            if (article?.descriptionColor)
                doc.setTextColor(article?.descriptionColor ?? ''); // Set dynamic color
            else
                doc.setTextColor(0, 0, 0); // Set dynamic color
            const lines = doc.splitTextToSize(article?.description ?? '', pageWidth - 20); // Wrap text
            lines.forEach(line => {
                doc.text(line, leftX, y);
                y += descriptionLineHeight;
            });
            // Calculate the width of the title to position the subtitle correctly
            const titleWidth = doc.getTextWidth(article?.description ?? '');
            // Set subtitle font and add it next to the title
            if (article?.priceDesc) {
                doc.setFont("helvetica", "normal", "bold");
                doc.setFontSize(9);
                doc.text(article?.priceDesc ?? '', leftX + titleWidth + 3, y - 4); // Add a small space after title
            }
            y += descriptionMarginBottom;
        }


        // Helper function to add a bordered table with full-page width
        function addTable(headers, data) {
            addPage(); // Add a new page if needed
            doc.setFontSize(7);
            doc.setFont("helvetica", "normal");

            const tableY = y; // Initial Y position for the table
            const cellHeight = 5; // Row height
            const tableMarginBottom = 10; // Space after table

            const tableWidth = pageWidth - 20; // Full table width
            const columnWidths = headers.map((header, colIndex) => {
                const headerWidth = doc.getTextWidth(header ?? '') + 4; // Add padding
                const maxDataWidth = data.reduce((max, row) => {
                    const cellWidth = doc.getTextWidth(row[colIndex] ?? '') + 4; // Add padding
                    return Math.max(max, cellWidth);
                }, 0);
                return Math.max(headerWidth, maxDataWidth); // Choose the larger value
            });

            // Calculate the proportional width for each column
            const totalOriginalWidth = columnWidths.reduce((sum, width) => sum + width, 0);
            const proportionalWidths = columnWidths.map(width => (width / totalOriginalWidth) * tableWidth);

            // Draw headers with proportional widths
            let currentX = leftX;
            headers.forEach((header, index) => {
                const cellWidth = proportionalWidths[index];
                doc.rect(currentX, tableY, cellWidth, cellHeight); // Draw border for header cell
                doc.text(header ?? '', currentX + 2, tableY + cellHeight / 2 + 1);  // Center text vertically
                currentX += cellWidth;
                addPage(); // Add a new page if needed
            });

            y += cellHeight;

            // Draw data rows with proportional widths
            data.forEach(row => {
                currentX = leftX;
                row.forEach((cell, index) => {
                    const cellWidth = proportionalWidths[index];
                    doc.rect(currentX, y, cellWidth, cellHeight); // Draw border for each cell
                    doc.text(cell ?? '', currentX + 2, y + cellHeight / 2 + 1); // Center text vertically
                    currentX += cellWidth;
                });
                addPage(); // Add a new page if needed
                y += cellHeight;
            });

            y += tableMarginBottom; // Extra space after table
        }


        doc.setTextColor(0, 0, 0); // White text
        doc.setFont("helvetica", "normal", "bold");
        doc.setFontSize(14);
        doc.text(typeName, pageWidth / 2, y, { align: "center" });
        y += 6

        // Add personal information to the PDF
        searchInfo();
        doc.setFont("helvetica", "normal", "normal");
        doc.setFontSize(8);
        y += 4

        // Loop through articles and render content dynamically
        firstArticles.forEach(article => {
            if (article?.title)
                addTitleAndSubtitle(article);
            if (article?.description) addDescription(article);
            if (article?.table) addTable(article?.table.headers, article?.table.data);
        });

        y += 6;        

        if (typeOfFile == 'print') {
            doc.autoPrint()
            window.open(doc.output("bloburl"))
        } else if (typeOfFile == "pdf") {
            doc.save(typeName + '.pdf');
        } else if (typeOfFile == "mail") {
            doc.save(typeName + '.pdf');
        }
    }
    const exportMembersExcel = async (data: any, typeName: string) => {
      const workbook = XLSX.utils.book_new();

      const rows: any[][] = [];

      // =====================================================
      // TITLE
      // =====================================================

      rows.push([typeName]);
      rows.push([]);

      // =====================================================
      // SEARCH / FILTER INFORMATION
      // =====================================================

      if (data?.filterBy?.name) {
        rows.push([
          translateToFrench("tables.members.name"),
          data.filterBy.name?.toString(),
        ]);
      }

      if (data?.filterBy?.email) {
        rows.push([
          translateToFrench("tables.members.email"),
          data.filterBy.email?.toString(),
        ]);
      }

      if (data?.filterBy?.tele) {
        rows.push([
          translateToFrench("tables.members.tele"),
          data.filterBy.tele?.toString(),
        ]);
      }

      if (data?.filterBy?.cin) {
        rows.push([
          translateToFrench("tables.members.cin"),
          data.filterBy.cin?.toString(),
        ]);
      }

      if (
        data?.filterBy?.dateBirth?.[0] != null &&
        data?.filterBy?.dateBirth?.[1]
      ) {
        rows.push([
          translateToFrench("tables.members.dateBirth"),
          `${dayjs(String(data.filterBy.dateBirth[0])).format(
            "DD/MM/YYYY",
          )} -- ${dayjs(String(data.filterBy.dateBirth[1])).format(
            "DD/MM/YYYY",
          )}`,
        ]);
      }

      if (data?.filterBy?.gender) {
        rows.push([
          translateToFrench("tables.members.gender"),
          data.filterBy.gender?.toString(),
        ]);
      }

      if (data?.filterBy?.contractNumber) {
        rows.push([
          translateToFrench("tables.members.contractNumber"),
          data.filterBy.contractNumber?.toString(),
        ]);
      }

      if (data?.filterBy?.seller) {
        rows.push([
          translateToFrench("tables.members.seller"),
          data.filterBy.seller?.toString(),
        ]);
      }

      // Empty row between filters and members
      rows.push([]);

      // =====================================================
      // MEMBERS HEADERS
      // =====================================================

      const headers = [
        translateToFrench("tables.members.contractNumber"),
        translateToFrench("tables.members.cin"),
        translateToFrench("tables.members.name"),
        translateToFrench("tables.members.tele"),
        translateToFrench("tables.members.seller"),
        translateToFrench("tables.members.status"),
      ];

      rows.push(headers);

      // =====================================================
      // MEMBERS DATA
      // =====================================================

      if (data?.members?.length) {
        data.members.forEach((item: any) => {
          rows.push([
            item?.contractNumber ? item.contractNumber.toString() : "-",

            item?.cin ? item.cin.toString() : "-",

            item?.name ? item.name.toString() : "-",

            item?.tele ? item.tele.toString() : "-",

            item?.seller?.name ? item.seller.name.toString() : "-",

            item?.subscription_status
              ? translateToFrench(
                  "status." + item.subscription_status.toString(),
                ) || "-"
              : "-",
          ]);
        });
      }

      // =====================================================
      // CREATE WORKSHEET
      // =====================================================

      const worksheet = XLSX.utils.aoa_to_sheet(rows);

      // =====================================================
      // COLUMN WIDTHS
      // =====================================================

      worksheet["!cols"] = [
        { wch: 22 }, // Contract number
        { wch: 18 }, // CIN
        { wch: 30 }, // Name
        { wch: 18 }, // Telephone
        { wch: 25 }, // Seller
        { wch: 20 }, // Status
      ];

      // Freeze the header/data area
      worksheet["!freeze"] = {
        xSplit: 0,
        ySplit: 1,
      };

      // =====================================================
      // ADD SHEET
      // =====================================================

      XLSX.utils.book_append_sheet(workbook, worksheet, "Members");

      // =====================================================
      // EXPORT
      // =====================================================

      XLSX.writeFile(workbook, `${typeName}.xlsx`);
    };
    /*
        const exportMembersBadgePDF = async (badgesTable: any) => {
            // Create a new jsPDF instance
            // const doc = new jsPDF();
    
    
            // console.log(badgesTable)
    
    
            // doc.html(badgesTable)
    
    
            // doc.save('seances.pdf') 
    
            if (!badgesTable) return;
    
    
    
            try {
    
                // Générer le PDF après conversion des images
                html2canvas(badgesTable, {
                    //  useCORS: true,
                    scale: 2,
                    allowTaint: false
                }).then((canvas) => {
                    const imgData = canvas.toDataURL("image/png");
                    const pdf = new jsPDF("p", "mm", "a4");
                    const imgWidth = 210;
                    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    
                    pdf.addImage(imgData, "PNG", 0, 10, imgWidth, imgHeight);
                    pdf.save("document.pdf");
    
    
                });
    
    
            } catch (error) {
                console.error("Erreur lors de la conversion des images :", error);
            }
    
    
        }
    
    */




    const VUE_APP_URL = process.env.VUE_APP_URL;
    // Helper function to convert an image URL to a Base64 data URL
    const imageToBase64 = async (url: string): Promise<string> => {
       
        
     //   const response = await fetch(`${VUE_APP_URL}${url}`, { mode: "cors" });
        const response = await fetch(`http://127.0.0.1:8000/cors-image/${url}`, { mode: "cors" });
        const blob = await response.blob();
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result as string);
            reader.readAsDataURL(blob);
        });
    };
    const exportMembersBadgePDF = async (members: any, canvasQrCode , typeOfFile :string) => {
        isRequestPDF.value = true
        errorPDF.value = false
        console.log(isRequestPDF.value)
        try {
            const badgeWidth = 220; // Width of the rectangle
            const centerX = badgeWidth / 2; // Exact center of the rectangle
            const pdf = new jsPDF({
                orientation: 'landscape',
                unit: 'pt',
                format: [badgeWidth, 130], // Badge size (85x55mm)
            });

            //  const pageWidth = pdf.internal.pageSize.getWidth(); // Get the page width
            const pageHeight = pdf.internal.pageSize.getHeight(); // Get the page height

            const imgWidth = 55; // Image width
            const imgHeight = 55; // Image height

            const centerHorizontal = 15; // Center X position (horizontal)
            const centerVertical = (pageHeight - imgHeight) / 2; // Center Y position (vertical)

            const centerTextHorizontal = 85; // Center X position (horizontal)
            const centerTextVertical = ((pageHeight) / 2) - 8; // Center Y position (vertical)



            // Loop through each member in the array
            for (let index = 0; index < members.length; index++) {

                const member = members[index];

                // For all members except the first, add a new page
                if (index > 0) {
                    pdf.addPage();
                }

                /** mn hna */
                if (!canvasQrCode) {
                    console.error("QR list container is not available");
                    return;
                }
                const canvas = canvasQrCode[index] as HTMLCanvasElement | undefined;
                if (!canvas) {
                    console.error(`Canvas for QR code ${index} not found`);
                    return;
                }


                // --- Badge Header ---
                pdf.setFillColor(39, 112, 157);
                pdf.rect(0, 0, badgeWidth, 20, "F");
                pdf.setFontSize(8);
                pdf.setTextColor(255, 255, 255);
                pdf.text("Numéro du contrat : " + member.contractNumber, 15, 13);

                // --- Member Photo ---
                // Get the QR code image as a data URL
                const imgData = canvas.toDataURL('image/png');
                // Add QR code image to PDF 
                pdf.addImage(imgData, "JPEG", centerHorizontal, centerVertical, imgWidth, imgHeight);


                // --- Member Information ---
                pdf.setFontSize(8);
                pdf.setTextColor(0, 0, 0);
                pdf.setFont("helvetica", "bold");
                pdf.text((member.name).toUpperCase(), (centerTextHorizontal), (centerTextVertical));

                pdf.setFontSize(7);
                pdf.setFont("helvetica", "normal");
                pdf.text("Matricule : " + member.matricule, (centerTextHorizontal), (centerTextVertical + 16));


                // --- Badge Footer --- 

                const text = "Scannez et confirmez votre présence";
                pdf.setFillColor(39, 112, 157);

                pdf.rect(0, 110, badgeWidth, 20, "F");
                pdf.setFontSize(7);
                pdf.setTextColor(255, 255, 255);
                // Center text automatically
                pdf.text(text, centerX, 123, { align: "center" })

            }

            // Save the generated PDF
            
            if (typeOfFile == 'print') {
                pdf.autoPrint()
                window.open(pdf.output("bloburl"))
            } else if (typeOfFile == "pdf") {
               pdf.save("adherent-badge.pdf"); 
            } else if (typeOfFile == "mail") {
               pdf.save("adherent-badge.pdf"); 
            }
        } catch (err: any) {
            errorPDF.value = true;
            isRequestPDF.value = false
        } finally {
            isRequestPDF.value = false
            console.log('hello pdf')
            console.log(isRequestPDF.value)
        }
        
    };

    return {
        exportMembersPDF,
        exportMembersExcel,
        isRequestPDF,
        
        exportMembersBadgePDF,

    };
}


